<!-- =========================================================================================
  File Name: Profile.vue
  Description: Profile Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <form action>
      <div class="vx-row mb-6">
        <div class="vx-col md:w-1/2 w-full ql-container">
          <!-- <h3 class="pt-3">Add/Edit About in HTML</h3> -->
          <h3 class="pt-3">Add/Edit About</h3>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Title</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required'"
                name="title"
                placeholder="Title"
                class="w-full"
                v-model="taskLocal.title"
                :color="validateForm ? 'success' : 'danger'"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>App short Description</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-textarea
                v-validate="'required'"
                name="app_short_description"
                placeholder="App short Description"
                class="w-full"
                v-model="taskLocal.app_short_description"
                :color="validateForm ? 'success' : 'danger'"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>App Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required'"
                name="app_name"
                placeholder="App Name"
                class="w-full"
                v-model="taskLocal.app_name"
                :color="validateForm ? 'success' : 'danger'"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>App Version</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required'"
                name="app_version"
                placeholder="App Version"
                class="w-full"
                v-model="taskLocal.app_version"
                :color="validateForm ? 'success' : 'danger'"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Company Address</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required'"
                name="company_address"
                placeholder="Company Address"
                class="w-full"
                v-model="taskLocal.company_address"
                :color="validateForm ? 'success' : 'danger'"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>App Long Description</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-textarea
                v-validate="'required'"
                name="app_long_description"
                placeholder="App Long Description"
                class="w-full"
                v-model="taskLocal.app_long_description"
                :color="validateForm ? 'success' : 'danger'"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Age Limit Description</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required'"
                name="age_limit_description"
                placeholder="Age Limit Description"
                class="w-full"
                v-model="taskLocal.age_limit_description"
                :color="validateForm ? 'success' : 'danger'"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Foot Notes</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span>Intro Text</span>
              <vs-input
                v-validate="'required'"
                name="intro_text"
                placeholder="Intro Text"
                class="w-full"
                v-model="taskLocal.foot_notes.intro_text"
                :color="validateForm ? 'success' : 'danger'"
              />
              <span>Items</span>
              <div
                :key="index"
                v-for="(item, index) in taskLocal.foot_notes.items"
              >
                <feather-icon
                  @click.stop="deleteOptions(index)"
                  v-if="taskLocal.foot_notes.items.length > 1 && index != 0"
                  icon="MinusCircleIcon"
                  svgClasses="w-6 h-6 hover:text-danger stroke-current"
                  class="ml-2 cursor-pointer add-new-btn"
                />

                <vs-input
                  v-validate="'required'"
                  name="items"
                  :placeholder="'Item' + (index + 1)"
                  class="w-full mt-2"
                  v-model="taskLocal.foot_notes.items[index]"
                  :color="validateForm ? 'success' : 'danger'"
                />
              </div>

              <vs-button
                class="w-small add-new-btn"
                @click="addNewOption"
                size="small"
                >Add New</vs-button
              >
            </div>
          </div>

          <!-- <vs-textarea
            v-validate="'required'"
            class="ql-container color"
            rows="22"
            placeholder="Insert text here"
            v-model="content"
            :color="validateForm ? 'success' : 'danger'"
          /> -->
          <div class="p-4">
            <vs-button
              @click="submitAboutText"
              class="w-full"
              :disabled="!validateForm"
            >
              Submit
            </vs-button>
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <h3 class="pt-3">View About App</h3>
          <div class="output">
            <h2>{{ taskLocal.title }}</h2>
            <p>{{ taskLocal.app_short_description }}</p>
            <div class="hr"></div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3">
                <img
                  v-if="taskLocal.app_name"
                  src="@/assets/images/about/icon_app_name.png"
                  class="image-size"
                />
              </div>
              <div class="vx-col sm:w-2/3">
                <p>{{ taskLocal.app_name }}</p>
              </div>
            </div>
            <div class="hr"></div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3">
                <img
                  v-if="taskLocal.app_version"
                  src="@/assets/images/about/icon_app_version.png"
                  class="image-size"
                />
              </div>
              <div class="vx-col sm:w-2/3">
                <p>{{ taskLocal.app_version }}</p>
              </div>
            </div>
            <div class="hr"></div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3">
                <img
                  v-if="taskLocal.company_address"
                  src="@/assets/images/about/icon_company_address.png"
                  class="image-size"
                />
              </div>
              <div class="vx-col sm:w-2/3">
                <p>{{ taskLocal.company_address }}</p>
              </div>
            </div>
            <div class="hr"></div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3">
              <img src="" alt="">
                <img
                  v-if="taskLocal.app_long_description"
                  src="@/assets/images/about/icon_about_company.png"
                  class="image-size"
                />
              </div>
              <div class="vx-col sm:w-2/3">
                <p>{{ taskLocal.app_long_description }}</p>
              </div>
            </div>
            <div class="hr"></div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3">
                <img
                  v-if="taskLocal.age_limit_description"
                    src="@/assets/images/about/icon_warning.png"
                  class="image-size"
                />
              </div>
              <div class="vx-col sm:w-2/3">
                <p>{{ taskLocal.age_limit_description }}</p>
              </div>
            </div>
            <div class="hr"></div>
            <div class="">
              <p>{{ taskLocal.foot_notes.intro_text }}</p>
              <div class="">
                <ul>
                  <li
                    :key="index"
                    v-for="(item, index) in taskLocal.foot_notes.items"
                    class="items-li"
                  >
                    <p>{{ item }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="vx-col md:w-1/2 w-full">
          <h3 class="pt-3">View About App</h3>
          <div class="output" v-html="content"></div>
        </div> -->
      </div>
    </form>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import DataProvider from "../../services/data-provider";

export default {
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: ["code-block"],
        },
        theme: "snow", // or 'bubble'
      },
      taskLocal: {
        title: "",
        app_short_description: "",
        app_name: "",
        app_version: "",
        company_address: "",
        app_long_description: "",
        age_limit_description: "",
        foot_notes: {
          intro_text: "",
          items: [null],
        },
      },
      content: ``,
    };
  },
  methods: {
    addNewOption() {
      this.taskLocal.foot_notes.items.push("");
    },
    deleteOptions(i) {
      this.taskLocal.foot_notes.items.splice(i, 1);
    },
    submitAboutText() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          // DataProvider.postDataToCloud("/about", {
          //   app_info: this.content,
          // }).then(
          DataProvider.postDataToCloud("/about", this.taskLocal).then(
            (data) => {
              console.log("data", data);
              this.$vs.loading.close();
            },
            (err) => {
              this.$vs.loading.close();
              DataProvider.sendSentryErrorLog(err)
              if (err.message.includes("403")) {
                this.$vs.notify({
                  color: "warning",
                  title: "Access denied!",
                });
              }
            }
          );
        }
      });
    },
    getData() {
      this.$vs.loading();
      DataProvider.getDataFromCloud("/about").then(
        (data) => {
          console.log("getDataFromCloud:", data);
          // if (data.data) this.content = data.data.app_info;
          if (data.data.app_name) {
            this.taskLocal = data.data;
          }
          this.$vs.loading.close();
        },
        (err) => {
          DataProvider.sendSentryErrorLog(err)
          this.$vs.loading.close();
        }
      );
    },
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  mounted() {
    this.getData();
  },
  components: {
    quillEditor,
  },
  beforeDestroy() {
    // if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
};
</script>


<style lang="scss">
.ql-container {
  min-height: 500px;
}
.color {
  background: #fff;
}
.output {
  //   margin-top: 10px;
  border: 1px solid #e8e8e8;
  min-height: 500px;
  padding: 10px;
  background: #fff;
}
.add-new-btn {
  float: right;
  margin: 6px;
  z-index: 9;
}
.hr {
  width: 100%;
  border-top: 0.5px solid #e2e1e1;
  margin-top: 10px;
  margin-bottom: 10px;
}
.image-size{
  max-width: 50px;
  float: right;
}
// @import "@/assets/scss/vuexy/pages/profile.scss";
</style>
